module.exports = __webpack_public_path__ + "img/TeilGanzes.0fddb088.png";